import { Component, Injector, ViewChild, OnInit, Input, TemplateRef, AfterViewInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { PerguntaEnergiaDTO, TipoPerguntaEnum, QuestionarioRespostaEnergiaDTO, OpcaoQuestionarioRespostaEnergiaDTO, TipoValorPerguntaEnum, TamanhoPerguntaEnum, TipoCustomizacaoEnum, ResponsavelAvaliacaoEconomiaDTO, MaquinasEquipamentosDTO } from '../../model/questionario.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-questionario-qualificacao',
    templateUrl: './questionario-qualificacao.component.html',
    styleUrls: ['./questionario-qualificacao.component.scss'],
    standalone: false
})

export class QuestionarioQualificacaoComponent implements OnInit, AfterViewInit {

    @Input()
    public listaPerguntas: PerguntaEnergiaDTO[];

    @Input()
    public isEsco: boolean;

    private _listaResposta: QuestionarioRespostaEnergiaDTO[];
    @Input() set listaResposta(value: QuestionarioRespostaEnergiaDTO[]) {
        this._listaResposta = value;
        if (this._listaResposta) {
            this.preencherTela();
        }
    }

    @Input()
    public listaMaquinasEquipamentos: MaquinasEquipamentosDTO[];

    @ViewChild('RESPONSAVEL_PELA_AVALIACAO')
    private RESPONSAVEL_PELA_AVALIACAO: TemplateRef<any>;

    @ViewChild('MAQUINAS_EQUIPAMENTOS')
    private MAQUINAS_EQUIPAMENTOS: TemplateRef<any>;

    public questionarioForm: UntypedFormGroup;
    public formGroup: UntypedFormGroup;

    public respostas: UntypedFormArray = new UntypedFormArray([]);

    private static readonly TIPO_INPUT_RADIO: string = 'radio';
    private static readonly TIPO_INPUT_CHECKBOX: string = 'checkbox';
    private static readonly TIPO_INPUT_TEXT: string = 'text';
    private static readonly TIPO_INPUT_CUSTOM: string = 'custom';
    private static readonly TIPO_INPUT_DATE: string = 'date';

    private static readonly CAMPO_CUSTOMIZADO_IDENTIFICACAO_RESPONSAVEL_AVALIACAO = 'identificacao_responsavel_avaliacao';

    public listaCodigoEquipamentosSelecionados = [];
    public listaAtualizadaEquipamentosSelecionados: any[] = [];

    constructor(
        protected injector: Injector,
        private formBuilder: UntypedFormBuilder,
        private sanitizer: DomSanitizer) 
    {}

    ngAfterViewInit(): void {
        /* Atualizar o template antes de acabar a geração do formulário gera Mudança em atributo chegado. Necessário aguardar um pouco para que o formulário 
           termine a renderização e checagem, já que o binding dos componentes acontece em tempo diferente da inicialização do formulário */
        setTimeout(() => {
            this.listaPerguntas.forEach(pergunta => {
                if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
                    pergunta.frontCustomTemplate = this[pergunta.tipoCustomizacao];
                }
            });
        }, 500);
    }

    ngOnInit() {

        let respostasFormArray: UntypedFormArray = this.formBuilder.array([]);
        let idUltimoGrupo: number = -1;

        this.listaPerguntas.forEach(pergunta => {

            pergunta.frontTitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.tituloPergunta);
            pergunta.frontSubtitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.textoPergunta);
            if (pergunta.grupo) {
                pergunta.grupo.frontTitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.grupo.titulo);
                pergunta.grupo.frontSubtitulo = this.sanitizer.bypassSecurityTrustHtml(pergunta.grupo.subtitulo);
            }

            if (this.verificaPerguntaTemTextoComplementar(pergunta)) {
                pergunta.frontTemTextoComplementar = true;
            }

            idUltimoGrupo = this.trataGrupoPergunta(pergunta, idUltimoGrupo);

            let tipoInput = this.getTipoInput(pergunta);
            if (tipoInput == QuestionarioQualificacaoComponent.TIPO_INPUT_RADIO) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl('', Validators.required)
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioQualificacaoComponent.TIPO_INPUT_CHECKBOX) {
                let perguntaCheckBoxArray: UntypedFormArray = new UntypedFormArray([], minSelectedCheckboxes(1));
                for (let indOpResposta = 0; indOpResposta < pergunta.listaOpcoes.length; indOpResposta++) {
                    perguntaCheckBoxArray.push(new UntypedFormControl(false));
                }

                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: perguntaCheckBoxArray,
                    textoComplementar: new UntypedFormControl('')
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioQualificacaoComponent.TIPO_INPUT_TEXT) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl('', Validators.required)
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioQualificacaoComponent.TIPO_INPUT_DATE) {
                let respostaFormGroup: AbstractControl = this.formBuilder.group({
                    idPergunta: pergunta.id,
                    resposta: new UntypedFormControl(undefined, Validators.required)
                });
                respostasFormArray.push(respostaFormGroup);
            } else if (tipoInput == QuestionarioQualificacaoComponent.TIPO_INPUT_CUSTOM) {
                let respostaFormGroup: AbstractControl = this.criaPerguntaCustomizada(pergunta);
                respostasFormArray.push(respostaFormGroup);
            }

        });

        this.formGroup = this.formBuilder.group({
            respostas: respostasFormArray
        });

        this.adicionarOpcao();
        this.preencherTela();
    }


    public get respostasQuestionario(): UntypedFormArray {
        return this.formGroup.get('respostas') as UntypedFormArray;
    }
    
    public get haEquipamentosFiname(): boolean {
        return this.listaCodigoEquipamentosSelecionados 
            && this.listaCodigoEquipamentosSelecionados.filter(l => l != null).length > 0;
    }
    
    public get haEquipamentosFinameSemQuantidadeZeroNegativo(): boolean {
        return !!this.listaCodigoEquipamentosSelecionados?.some(
                equip => equip != null 
                && equip.codigoFiname != null 
                && (equip.quantidade === null || equip.quantidade <= 0)
        );
    }

    private trataGrupoPergunta(pergunta: PerguntaEnergiaDTO, idUltimoGrupo: number): number {
        if (!pergunta.grupo) {
            return -1;
        }

        if (!idUltimoGrupo || idUltimoGrupo == -1 || idUltimoGrupo != pergunta.grupo.id) {
            idUltimoGrupo = pergunta.grupo.id;
            pergunta.frontIsPerguntaNovoGrupo = true;
        }

        return idUltimoGrupo;
    }

    private criaPerguntaCustomizada(pergunta: PerguntaEnergiaDTO): AbstractControl {
        let customFormGroup: AbstractControl = undefined;

        if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
            customFormGroup = this.formBuilder.group({
                idPergunta: pergunta.id,
                nomeInterno: pergunta.tipoCustomizacao,
                cnpj: new UntypedFormControl(''),
                cpf: new UntypedFormControl(''),
                nome: new UntypedFormControl(''),
                profissao: new UntypedFormControl(''),
                registro: new UntypedFormControl(''),
                orgaoRegistro: new UntypedFormControl(''),
                unidadeFederacaoOrgao: new UntypedFormControl('')
            });

        }

        if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.MAQUINAS_EQUIPAMENTOS) {
            customFormGroup = this.formBuilder.group({
                idPergunta: pergunta.id,
                nomeInterno: pergunta.tipoCustomizacao,
            });

        }

        return customFormGroup;
    }

    public retornaRespostasPreenchidas(): QuestionarioRespostaEnergiaDTO[] {
        let listaResposta: QuestionarioRespostaEnergiaDTO[] = [];
        let outer = this;

        this.respostasQuestionario.controls.forEach(ctrlGroupResposta => {
            let itemResposta = new QuestionarioRespostaEnergiaDTO();
            let formGroupResposta: UntypedFormGroup = ctrlGroupResposta as UntypedFormGroup;
            itemResposta.idPergunta = formGroupResposta.controls.idPergunta.value;
            let pergunta = outer.getPerguntaPorId(itemResposta.idPergunta);

            if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.MAQUINAS_EQUIPAMENTOS) {
                this.trataRespostaCampoListaEquipamentos(pergunta.tipoCustomizacao, formGroupResposta, itemResposta);
            }

            else {

                if (formGroupResposta.controls.nomeInterno) { // campo customizado
                    this.trataRespostaCampoCustomizado(formGroupResposta.controls.nomeInterno.value, formGroupResposta, itemResposta);
                } else {
                    let auxResposta: any = formGroupResposta.controls.resposta.value;
                    if (Array.isArray(auxResposta)) {
                        itemResposta.conteudo = this.trataRespostaArray(itemResposta.idPergunta, auxResposta);
                        itemResposta.conteudoComplementar = formGroupResposta.controls.textoComplementar.value;
                    } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE && pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
                        outer.trataRespostaDate(auxResposta, itemResposta);
                    } else {
                        itemResposta.conteudo = auxResposta;
                    }
                }
            }

            listaResposta.push(itemResposta);

        });

        return listaResposta;
    }

    private trataRespostaCampoCustomizado(nomeInterno: string, formGroup: UntypedFormGroup, itemResposta: QuestionarioRespostaEnergiaDTO): void {
        if (nomeInterno == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
            const cnpjResponsavelAvaliacao = formGroup.controls.cnpj.value;
            itemResposta.conteudo = `cnpj=${cnpjResponsavelAvaliacao ? cnpjResponsavelAvaliacao : ''};cpf=${formGroup.controls.cpf.value};nome=${formGroup.controls.nome.value};profissao=${formGroup.controls.profissao.value};numeroRegistroProfissional=${formGroup.controls.registro.value};orgaoRegistro=${formGroup.controls.orgaoRegistro.value};unidadeFederacaoOrgao=${formGroup.controls.unidadeFederacaoOrgao.value}`;
        } else {
            throw new Error('Campo customizado desconhecido');
        }
    }

    private trataRespostaArray(idPergunta: number, auxResposta: boolean[]): string {
        let perguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
        let idsConcatenados: string = '';
        for (let ind = 0; ind < perguntaEnergiaDTO.listaOpcoes.length; ind++) {
            const boolResp: boolean = auxResposta[ind];
            if (boolResp) {
                if (idsConcatenados.length > 0) {
                    idsConcatenados += ';';
                }
                idsConcatenados += perguntaEnergiaDTO.listaOpcoes[ind].id;
            }
        };

        return idsConcatenados;
    }

    private trataRespostaDate(valor: any, itemResposta: QuestionarioRespostaEnergiaDTO): void {
        if (!valor) {
            return;
        }
        itemResposta.conteudo = moment(valor).format('YYYY-MM-DD');

    }

    public getTipoInput(pergunta: PerguntaEnergiaDTO): string {
        if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_UNICA) {
            return QuestionarioQualificacaoComponent.TIPO_INPUT_RADIO;
        } else if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_MULTIPLA || pergunta.tipoPergunta == TipoPerguntaEnum.LISTA_COM_REDFLAG) {
            return QuestionarioQualificacaoComponent.TIPO_INPUT_CHECKBOX;
        } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE) {
            if (pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
                return QuestionarioQualificacaoComponent.TIPO_INPUT_DATE;
            } else {
                return QuestionarioQualificacaoComponent.TIPO_INPUT_TEXT;
            }
        } else if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
            return QuestionarioQualificacaoComponent.TIPO_INPUT_CUSTOM;
        }
    }

    private getPerguntaPorId(idPergunta: number) {
        let perguntaEncontrada = null;
        this.listaPerguntas.forEach(pergunta => {
            if (pergunta.id == idPergunta) {
                perguntaEncontrada = pergunta;
            }
        });

        return perguntaEncontrada;
    }

    public checkboxChange(event: any, opcaoResposta: OpcaoQuestionarioRespostaEnergiaDTO, idPergunta: number) {
        let perguntaAtual: PerguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
        perguntaAtual.frontMostrarTextoComplementar = event.target.checked;
        if (opcaoResposta.exigeTextoComplementar) {
            perguntaAtual.frontMostrarTextoComplementar = event.target.checked;
        }
    }

    private verificaPerguntaTemTextoComplementar(pergunta: PerguntaEnergiaDTO): boolean {
        let retorno = false;
        if (pergunta.listaOpcoes) {
            pergunta.listaOpcoes.forEach(opcao => {
                if (opcao.exigeTextoComplementar) {
                    retorno = true;
                }
            });
        }

        return retorno;
    }

    public getMascaraPergunta(tipo: TipoValorPerguntaEnum) {
        if (tipo == TipoValorPerguntaEnum.NUMERO_INTEIRO) {
            return 'INTEIRO';
        } else if (tipo == TipoValorPerguntaEnum.NUMERO_DECIMAL) {
            return 'DECIMAL';
        } else if (tipo == TipoValorPerguntaEnum.CNPJ) {
            return 'CNPJ';
        } else if (tipo == TipoValorPerguntaEnum.CEP) {
            return 'CEP';
        } else {
            return null;
        }
    }

    public getClassTamanhoPergunta(pergunta: PerguntaEnergiaDTO) {
        if (pergunta.tamanho == TamanhoPerguntaEnum.MUITO_PEQUENO) {
            return 'col-md-1';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.PEQUENO) {
            return 'col-md-3';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.MEDIO) {
            return 'col-md-6';
        } else if (pergunta.tamanho == TamanhoPerguntaEnum.GRANDE) {
            return 'col-md-12';
        }

        return 'col-md-6';
    }

    public preencherTela(): void {
        if (this.formGroup && this._listaResposta) {
            this.respostasQuestionario.controls.forEach(ctrlGroupResposta => {
                let formGroupResposta: UntypedFormGroup = ctrlGroupResposta as UntypedFormGroup;
                let idPergunta: number = formGroupResposta.controls.idPergunta.value;
                let pergunta: PerguntaEnergiaDTO = this.getPerguntaPorId(idPergunta);
                let respCarregada: QuestionarioRespostaEnergiaDTO = this.getValueFromResposta(idPergunta);

                if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_UNICA) {
                    formGroupResposta.patchValue({
                        resposta: this.trataConteudoRespostaEscolhaUnica(respCarregada)
                    });
                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.TEXTO_LIVRE) {
                    let conteudo = this.trataConteudoTextoLivreCarregado(pergunta, respCarregada);
                    formGroupResposta.patchValue({
                        resposta: conteudo
                    });
                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.ESCOLHA_MULTIPLA ||
                    pergunta.tipoPergunta == TipoPerguntaEnum.LISTA_COM_REDFLAG) {
                    let boolVet: boolean[] = [];
                    let respSplit = respCarregada.conteudo.split(';');
                    for (let indOpcao = 0; indOpcao < pergunta.listaOpcoes.length; indOpcao++) {
                        let achou = false;
                        for (let ind = 0; ind < respSplit.length; ind++) {
                            if (pergunta.listaOpcoes[indOpcao].id == Number(respSplit[ind])) {
                                achou = true;
                                if (pergunta.listaOpcoes[indOpcao].exigeTextoComplementar) {
                                    pergunta.frontMostrarTextoComplementar = true;
                                }
                                break;
                            }
                        }
                        boolVet.push(achou);
                    }
                    formGroupResposta.patchValue({
                        resposta: boolVet,
                        textoComplementar: respCarregada.conteudoComplementar
                    });

                } else if (pergunta.tipoPergunta == TipoPerguntaEnum.PERSONALIZADA) {
                    if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.RESPONSAVEL_PELA_AVALIACAO) {
                        let obj: ResponsavelAvaliacaoEconomiaDTO = this.carregaResponsavelAvaliacao(pergunta, respCarregada.conteudo);
                        formGroupResposta.patchValue({
                            cnpj: obj.cnpj,
                            cpf: obj.cpf,
                            nome: obj.nome,
                            profissao: obj.profissao,
                            registro: obj.numeroRegistroProfissional,
                            orgaoRegistro: obj.orgaoRegistro,
                            unidadeFederacaoOrgao: obj.unidadeFederacaoOrgao,
                        });
                    }

                    if (pergunta.tipoCustomizacao == TipoCustomizacaoEnum.MAQUINAS_EQUIPAMENTOS) {
                        this.carregaListaMaquinasEquipamentos(respCarregada.conteudo);
                    }
                }


            });
        }
    }

    private getValueFromResposta(idPergunta: number): QuestionarioRespostaEnergiaDTO {
        for (let ind = 0; ind < this._listaResposta.length; ind++) {
            if (this._listaResposta[ind].idPergunta == idPergunta) {
                return this._listaResposta[ind];
            }
        }
    }

    private carregaResponsavelAvaliacao(pergunta: PerguntaEnergiaDTO, conteudo: string): ResponsavelAvaliacaoEconomiaDTO {
        let conteudoSplit: string[] = conteudo.split(";")
        let obj: ResponsavelAvaliacaoEconomiaDTO = new ResponsavelAvaliacaoEconomiaDTO();
        for (let indCampo = 0; indCampo < conteudoSplit.length; indCampo++) {
            if (conteudoSplit[indCampo].startsWith('cnpj=')) {
                obj.cnpj = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('cpf=')) {
                obj.cpf = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('nome=')) {
                obj.nome = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('profissao=')) {
                obj.profissao = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('numeroRegistroProfissional=')) {
                obj.numeroRegistroProfissional = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('orgaoRegistro=')) {
                obj.orgaoRegistro = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else if (conteudoSplit[indCampo].startsWith('unidadeFederacaoOrgao=')) {
                obj.unidadeFederacaoOrgao = conteudoSplit[indCampo].substring(conteudoSplit[indCampo].indexOf('=') + 1);
            } else {
                throw new Error("Campo inválido para a pergunta " + pergunta.id) + ". Conteudo: " + conteudo;
            }
        }

        return obj;
    }

    private carregaListaMaquinasEquipamentos(conteudo: string): void {
        this.listaCodigoEquipamentosSelecionados = conteudo.split(';').map(item => JSON.parse(item) as MaquinasEquipamentosDTO);                
        this.sincronizarLista();
    }

    private trataConteudoTextoLivreCarregado(pergunta: PerguntaEnergiaDTO, resposta: QuestionarioRespostaEnergiaDTO): string | Date {
        if (pergunta.tipoValor == TipoValorPerguntaEnum.DATA) {
            let date: Date = moment(resposta.conteudo, 'YYYY-MM-DD').toDate();
            return date;
        }
        return resposta?.conteudo
    }

    private trataConteudoRespostaEscolhaUnica(resposta: QuestionarioRespostaEnergiaDTO): number {
        if (resposta?.conteudo) {
            return Number(resposta.conteudo);
        } else {
            return undefined;
        }
    }

    /**
    * Esconder a pergunta caso ela seja somente para esco e o cliente atual não é uma esco
    * ou caso a pergunta seja para cliente não esco e o cliente atual é uma esco
    */
    public esconderPerguntaPorTipoTomador(pergunta: PerguntaEnergiaDTO): boolean {
        if (!pergunta.disponivelSomenteConsumidorFinal && !pergunta.disponivelSomenteEsco) {
            return false;
        }

        if (pergunta.disponivelSomenteConsumidorFinal && this.isEsco) {
            return true;
        }

        if (pergunta.disponivelSomenteEsco && !this.isEsco) {
            return true;
        }

    }

    trackByFn(index: number, item: any) {
        return index;
    }

    private sincronizarLista() {        
        if (this.listaCodigoEquipamentosSelecionados.length > 0) {               
            this.listaAtualizadaEquipamentosSelecionados = this.listaCodigoEquipamentosSelecionados
                .filter(item => item && item.codigoFiname != null)
                .map((item, index) => {                                        
                    const opcao = this.listaMaquinasEquipamentos.find(op => op.codigoFiname === item.codigoFiname);
                    return {
                        codigoFiname: item.codigoFiname,
                        nomeItem: opcao?.nomeItem || null,
                        ordem: index,
                        quantidade: item.quantidade
                    };
                });
        }
    }

    salvarMudanca() {
        this.sincronizarLista();
    }

    adicionarEquipamento() {
        this.adicionarOpcao();
        this.sincronizarLista();
    }

    removerEquipamento(index) {
        this.listaCodigoEquipamentosSelecionados.splice(index, 1);
        this.sincronizarLista();
    }

    private trataRespostaCampoListaEquipamentos(nomeInterno: string, formGroup: UntypedFormGroup, itemResposta: QuestionarioRespostaEnergiaDTO): void {
        if (nomeInterno == TipoCustomizacaoEnum.MAQUINAS_EQUIPAMENTOS) {
            this.sincronizarLista();
            itemResposta.conteudo = `${this.listaAtualizadaEquipamentosSelecionados
                .filter(u => u.codigoFiname != null)
                .map(u => JSON.stringify(u)).join(';')}`;

        } else {
            throw new Error('Campo customizado desconhecido');
        }
    }

    adicionarOpcao() {
        this.listaCodigoEquipamentosSelecionados.push({
            codigoFiname: null,
            quantidade: null
        });
    }

    getOpcoesDisponiveis(itemAtual: any) {
        if(this.listaMaquinasEquipamentos!=null) {      
         return this.listaMaquinasEquipamentos.filter(item => {
            const jaSelecionado = this.listaCodigoEquipamentosSelecionados.some(selecionado => 
                selecionado !== itemAtual && selecionado.codigoFiname === item.codigoFiname);
                return !jaSelecionado;
        });

        }
        else{
            return null;
        }
    }

}

function minSelectedCheckboxes(min = 1): any {
    const validator: ValidatorFn = (formArray: UntypedFormArray) => {
        const totalSelected = formArray.controls
            // get a list of checkbox values (boolean)
            .map(control => control.value)
            // total up the number of checked checkboxes
            .reduce((prev, next) => next ? prev + next : prev, 0);

        // if the total is not greater than the minimum, return the error message
        return totalSelected >= min ? null : { required: true };
    };
}
